import { CheckCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ResearchBadgeProps {
  isResearchParticipant?: boolean;
  className?: string;
}

export function ResearchBadge({
  isResearchParticipant,
  className,
}: ResearchBadgeProps) {
  if (!isResearchParticipant) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={`cursor-help ${className}`}>
            <CheckCircle className="h-4 w-4 text-blue-500" />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Research Study Participant</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
